module.exports = __webpack_public_path__ + "img/title-bg.128a00d2.png";